import { render } from "./PlatformMentionEngagement.vue?vue&type=template&id=74d887ae"
import script from "./PlatformMentionEngagement.vue?vue&type=script&lang=js"
export * from "./PlatformMentionEngagement.vue?vue&type=script&lang=js"

import "./PlatformMentionEngagement.vue?vue&type=style&index=0&id=74d887ae&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__